import { render, staticRenderFns } from "./ChooseOrder.vue?vue&type=template&id=f13cf600&scoped=true&"
import script from "./ChooseOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrder.vue?vue&type=style&index=0&id=f13cf600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13cf600",
  null
  
)

export default component.exports